import { Language } from '@coolblue-development/constants';
export const STUDENT_DISCOUNT_PATHS = [
    '/studentenkorting/verificatie',
    '/student-discount/verification',
    '/reduction-etudiant/verification',
    '/studentenrabatt/verifizierung',
];
export const STOREFRONTS_PATHS_FOR_STUDENT_DISCOUNT = {
    [Language.DUTCH]: [
        '/laptops',
        '/laptops/back-to-school',
        '/back-to-school',
        '/laptops/apple-macbook',
        '/laptops/windows',
        '/laptops/hp',
        '/laptops/lenovo',
        '/laptops/asus',
        '/laptops/samsung',
        '/studentenkorting',
    ],
    [Language.ENGLISH]: [
        '/laptops',
        '/laptops/back-to-school',
        '/back-to-school',
        '/laptops/apple-macbook',
        '/laptops/windows',
        '/laptops/hp',
        '/laptops/lenovo',
        '/laptops/asus',
        '/laptops/samsung',
        '/student-discount',
    ],
    [Language.FRENCH]: [
        '/ordinateurs-portables',
        '/ordinateurs-portables/back-to-school',
        '/back-to-school',
        '/ordinateurs-portables/apple-macbook',
        '/ordinateurs-portables/windows',
        '/ordinateurs-portables/hp',
        '/ordinateurs-portables/lenovo',
        '/ordinateurs-portables/asus',
        '/ordinateurs-portables/samsung',
        '/reduction-etudiant',
    ],
    [Language.GERMAN]: [
        '/laptops',
        '/laptops/back-to-school',
        '/back-to-school',
        '/laptops/apple-macbook',
        '/laptops/windows',
        '/laptops/hp',
        '/laptops/lenovo',
        '/laptops/asus',
        '/laptops/samsung',
        '/studentenrabatt',
    ],
};
//# sourceMappingURL=urls.js.map